import gql from 'graphql-tag';

import { courseFragment } from '~/shared/graphql-queries/courses/index';

export default gql`
  mutation createOneCourseMutation($record: CreateOneCourseInput!) {
    createOneCourseMutation(record: $record) {
      recordId
      record {
        ...CourseFragment
      }
      message
      title
    }
  }
  ${courseFragment}
`;
